import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingFonts } from 'helpers/constants';

const CONTAINER_WIDTH = 518;

export const useStyles = makeStyles((theme) => ({
  '@global': {
    '#root, #main-footer p': {
      backgroundColor: '#F9FAFB',
    },
  },
  root: {
    width: '100%',
    maxWidth: CONTAINER_WIDTH,
    margin: `${theme.spacing(4)}px auto`,
    fontFamily: ERebrandingFonts.OPENSANS,
    position: 'relative',
  },
}));
